import { Loader2 } from 'lucide-react';
import { cn } from "../lib/utils.js";

type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

const SIZE_CLASS: Record<SpinnerSize, string> = {
  sm: 'h-3 w-3',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
  xl: 'h-6 w-6',
};

export function Spinner({
  size = 'md',
  className,
  label = 'Loading…',
}: {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}) {
  return (
    <Loader2
      role="status"
      aria-label={label}
      className={cn('animate-spin text-muted-foreground', SIZE_CLASS[size], className)}
    />
  );
}
